export const fontSizes = {
    inputLabel: "10px",
    paragraph: "14px",
    pageTitle: "40px",
    sectionTitle: "24px",

    medium: "24px"
};
